const TOP_OFFSET = 8;

export const getMenuScrollTop = (
  menu: { top: number },
  item: { top: number },
  scrollTop: number
): number => Math.max(0, scrollTop + item.top - menu.top - TOP_OFFSET);
